import React, { useState, Fragment } from 'react'
import { useForm, } from 'react-hook-form';
import {
    Button,
    Spinner,
} from "@material-tailwind/react";


import { useShared } from '../../hooks/useShared';
import AInput from '../fields/AInput';
import APDate from '../fields/APDate';
import ASelect from '../fields/ASelect';



export default function AdvanceSearch({ v }) {
    const { register, handleSubmit, formState: { errors, isDirty, isValid },watch,  setValue, control } = useForm({});
    const { auth } = useShared();
    const [isEmpty, setIsEmpty] = useState(true)
  


    const submit = (data) => {
        //Archive folder search
        if (v.searchInputFields[0]?.name=== "getArchiveCountByType") {
            data['getArchiveCountByType'] = true;
        }
        v.submit(data)
    }

    const mReset = () => {
        v.searchInputFields.map(f=>{
            setValue(f.name, null)
            return f;
        })
        setIsEmpty(true)


        const searchData = v.url ==="archives"?{getArchiveCountByType:true}:{}
        v.submit(searchData)
    }

 
    React.useEffect(() => {
        const subscription = watch((value, { name, type }) =>   setIsEmpty(Object.keys(value).length === 0));
        return () => subscription.unsubscribe();
      }, [watch]);


    console.log("dirty form ", isDirty, isValid)

    return (
        <div className={`md:flex flex-col items-start duration-500 overflow-hidden ${v.showSearchBox ? v.maxHeight + ' mb-10 !contents' : 'max-h-0'}  ease-out transition-all transform `}>

            <fieldset className="border border-solid border-gray-300 p-3 w-full rounded-md  relative">
                <legend className="text-sm text-main-color font-bold">جستجو</legend>

                <form className=" flex flex-col gap-4" onSubmit={handleSubmit(submit)}>
                    <div className=" grid md:grid-cols-6 gap-2 items-baseline">
                        {
                            v.searchInputFields?.map((data, i) => {
                                return (
                                    <Fragment key={i}>
                                        {!data?.hide && auth.hasRole(data.roles) &&
                                            <div  className={`grid col-span-6  ${data?.className}`}>
                                                {
                                                    data?.type === 'text' || data?.type === 'textarea' ?
                                                        <AInput v={{ register, errors, data }} />
                                                        : data?.type === 'select' ? <ASelect v={{ register, errors, control, data, type: "search" }} />
                                                            : data?.type === 'pdate' ? <APDate v={{ register, errors, setValue, control, data, type: "search" }} />
                                                                : null

                                                }
                                            </div>
                                        }
                                    </Fragment>
                                )
                            })
                        }

                    </div>

                    <div className='flex gap-4 md:justify-end'>
                        <Button className="btn1 w-full md:w-[8%] !px-1" size='sm' type="submit" disabled={isEmpty}>  {v?.loading?.all===1 ? <Spinner color="teal" className="h-4 w-4" /> : "جستجو"}    </Button>
                      <Button variant="outlined" size='sm' color="gray" onClick={() => mReset()}>Reset</Button>
                    </div>
                </form>
            </fieldset>
        </div>
    )
}

